window.zr = window.zr || {};
window.zr.event = window.zr.event || {};
window.zr.event.allFired = window.zr.event.allFired || '';

// Debugging
const { debug } = window.zr;

const { referrer } = document;
const logStyles = window.zr?.debugger?.logStyles ?? {};
const { zr: logStylesZr, name: logStylesName, reset: logStylesReset, cmd: logStylesCmd } = logStyles;

if (debug) {
  const logFormat = '%c zr%c.tracking %c Type %cwindow.zr.event.allFired%c to see all events fired this pageview';
  // eslint-disable-next-line no-console
  console.log(logFormat, logStylesZr, logStylesName, logStylesReset, logStylesCmd, logStylesReset);
}

function addEventAllFired(eventSystem, eventType) {
  if (window.zr && window.zr.event) {
    const event = `${eventType} ( ${eventSystem} front-end)`;
    window.zr.event.allFired += window.zr.event.allFired ? `, ${event}` : event;
  }
}

function handleIntSrc() {
  const { location, history } = window;
  const { hash } = location;

  const intSrcRegex = /\bintsrc=([^&=]+)&?/;

  const { intsrc } = window.zr.event;
  if (typeof intsrc !== 'undefined') {
    const hasIntSrc = hash.match(intSrcRegex);
    if (hasIntSrc) {
      let finalHash = hash.replace(intSrcRegex, '');
      if (finalHash === '#') {
        finalHash = '';
      }

      history.replaceState(null, null, location.pathname + location.search + finalHash);
      const [, input] = hasIntSrc;
      window.zr.event.intsrc = input;
    }
  }
  return window.zr.event.intsrc;
}

const maxEventsPerPage = 500;
window.zr.event.numFired = 0;

let eventHistory = [];

export default function logEvent(eventType, arg1, arg2) {
  // clean eventHistory
  const now = Date.now();
  eventHistory = eventHistory.filter((hist) => hist + 100 > now);

  if (eventHistory.length >= 10) {
    // eslint-disable-next-line no-console
    console.warn('Max events per second exceeded. Backing of queue.');
    return;
  }
  eventHistory.push(now);

  window.zr.event.numFired += 1;
  if (window.zr.event.numFired >= maxEventsPerPage) {
    if (window.zr.event.numFired === maxEventsPerPage) {
      // eslint-disable-next-line no-console
      console.warn('Max events per page exceeded. No longer recording.');
    }
    return;
  }

  let properties;
  let customCallback;

  // There are two ways to call this function.
  if (arguments.length === 2 && typeof arg1 === 'function') {
    customCallback = arg1;
  } else {
    properties = arg1;
    customCallback = arg2;
  }

  if (!eventType) {
    return;
  }

  function callback(data, textStatus) {
    if (customCallback !== undefined) {
      // eslint-disable-next-line prefer-rest-params
      customCallback.apply(this, arguments);
    }

    if (textStatus === 'success') {
      addEventAllFired('event-log', eventType);
    } else {
      // eslint-disable-next-line no-console
      console.warn(`Failed to log ${eventType} event`);
    }
  }

  const frontendProperties = {
    ...window.zr.event.frontendSuperProperties,
    // Add to the top to avoid command issues.
    referrer: referrer.substring(0, 300),
    screen_height: window.screen.height || 0,
    screen_width: window.screen.width || 0,
    window_height: window.innerHeight || 0, // returns height of browser viewport
    window_width: window.innerWidth || 0, // returns width of browser viewport
    fired_from: 'frontend', // Give some idea where these events came from
  };

  const propertiesClone = {
    ...properties,
    ...frontendProperties,
    ...window.zr.event.backendProperties,
  };

  const intsrc = handleIntSrc();
  if (typeof intsrc !== 'undefined') {
    propertiesClone.intsrc = intsrc;
  }

  if (window.zr.event.originType) {
    propertiesClone.origin_type = window.zr.event.originType;
  }

  const stringProperties = JSON.stringify(propertiesClone);

  const time = Date.now();
  const url = window.zr.event.log_url || '/events/log';
  const data = {
    event_type: eventType,
    properties: stringProperties,
    path: window.zr.event.request_path || window.location.pathname,
    time,
  };

  const doAjax = () => {
    if (debug) {
      const logFormat = `%c zr%c.tracking %c log_event: %c${eventType}`;
      // eslint-disable-next-line no-console
      console.log(logFormat, logStylesZr, logStylesName, logStylesCmd, logStylesReset, propertiesClone);
    }

    fetch({
      credentials: 'same-origin',
      url,
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(data),
    });
  };

  const doSendBeacon = () => {
    if (debug) {
      const logFormat = `%c zr%c.tracking %c sendBeacon log_event: %c${eventType}`;
      // eslint-disable-next-line no-console
      console.log(logFormat, logStylesZr, logStylesName, logStylesCmd, logStylesReset, propertiesClone);
    }

    const formData = new FormData();
    formData.append('event_type', data.event_type);
    formData.append('properties', data.properties);
    formData.append('path', data.path);
    formData.append('time', data.time);

    navigator.sendBeacon(url, formData);
  };

  if (navigator && navigator.sendBeacon) {
    doSendBeacon();
  } else {
    doAjax();
  }

  // Instantly call the callback
  callback({}, 'success');
}

// mixpanel.track is deprecated use log_event instead
window.mixpanel = {
  track: (eventType, properties) => {
    if ($.log_event) {
      logEvent(eventType, properties);
    }
  },
};

export const logPageView = (fireAgain, abTest) => {
  if (window.zr.event.pageViewFired && !fireAgain) {
    return;
  }
  const pagepath = window.location.pathname.replace(/\/(\?.*)?$/, '');
  const pagepathparam = window.location.pathname + window.location.search;

  const standardPageType = window.zr.event.backendProperties.page_type;
  const properties = window.zr.event.pageviewBackendProperties;

  let mixpanelPageType;
  switch (pagepath) {
    default: mixpanelPageType = 'Homepage'; break;
    case '': mixpanelPageType = 'Homepage'; break;
    case '/post-job': mixpanelPageType = 'Homepage'; break;

    case '/login': mixpanelPageType = 'Login'; break;
    case '/login/reset-password': mixpanelPageType = 'Reset Password'; break;
    case '/login/forgot-password': mixpanelPageType = 'Forgot Password'; break;
    case '/jobs/resume': mixpanelPageType = 'Resume Landing'; break;
    case '/mobile': mixpanelPageType = 'Mobile Landing'; break;

    case '/candidate/about': mixpanelPageType = 'Candidate - About'; break;
    case '/candidate/alerts': mixpanelPageType = 'Candidate - Alerts'; break;
    case '/candidate/my-jobs': mixpanelPageType = 'Candidate - My Jobs'; break;
    case '/candidate/resume': mixpanelPageType = 'Candidate - My Resume'; break;
    case '/candidate/references': mixpanelPageType = 'Candidate - References'; break;
    case '/candidate/notifications': mixpanelPageType = 'Candidate - Notifications'; break;
    case '/candidate/password': mixpanelPageType = 'Candidate - Password'; break;
    case '/candidate/unsubscribe': mixpanelPageType = 'Candidate - Unsubscribe'; break;
    case '/candidate/saved-jobs': mixpanelPageType = 'Candidate - Saved Jobs'; break;
    case '/candidate/suggested-jobs': mixpanelPageType = 'Candidate - Suggested Jobs'; break;
    case '/candidate/verify-identity': mixpanelPageType = 'Candidate - Verify Identity'; break;
    case '/candidate/gothired': mixpanelPageType = 'Candidate - Got Hired'; break;
    case '/candidate/onboard': mixpanelPageType = 'Candidate - Recruiter Onboarding'; break;
    case '/candidate/replace-mobile-resume': mixpanelPageType = 'Candidate - Replace Mobile Resume'; break;

    case '/employer': mixpanelPageType = 'Employer - Landing'; break;
    case '/user/purchase-plan-simple': mixpanelPageType = 'Employer - Paywall'; break;
    case '/quiz/create': mixpanelPageType = 'Employer - Quiz Create'; break;
    case '/user/create': mixpanelPageType = 'Employer - Reg Page'; break;
    case '/user/account': mixpanelPageType = 'Employer - User Account'; break;
    case '/post-a-job': mixpanelPageType = 'Employer - Post Job Landing'; break;
    case '/jobs/search': mixpanelPageType = 'Employer - Job Search Home'; break;

    // FB59534 Reactivation and associated pages
    case '/employer/reactivate': mixpanelPageType = 'Employer - Reactivate'; break;
    case '/user/purchase-upgrade': mixpanelPageType = 'Employer - Upgrade Plan'; break;
    case '/user/set-plan': mixpanelPageType = 'Employer - Select Plan'; break;
    case '/user/change-card': mixpanelPageType = 'Employer - Change CC'; break;

    // FB16295 Marketing Pages
    case '/candidate/testimonials': mixpanelPageType = 'Marketing'; break;
    case '/job-sites': mixpanelPageType = 'Marketing'; break;
    case '/pricing': mixpanelPageType = 'Marketing'; break;
    case '/enterprise': mixpanelPageType = 'Marketing'; break;
    case '/features': mixpanelPageType = 'Marketing'; break;
    case '/employer-reviews': mixpanelPageType = 'Marketing'; break;
    case '/guarantee': mixpanelPageType = 'Marketing'; break;
    case '/faq': mixpanelPageType = 'Marketing'; break;
    case '/sales': mixpanelPageType = 'Marketing'; break;
    case '/about': mixpanelPageType = 'Marketing'; break;
    // FB14666
    case '/scale': mixpanelPageType = 'Marketing'; break;
    // FB56381
    case '/find-a-job': mixpanelPageType = 'Vanity URL - SEM Simple'; break;
  }

  // Do not let this switch override Marketing pages.
  if (mixpanelPageType !== 'Marketing') {
    switch (standardPageType) {
      default: break;
      case 'Vanity URL': mixpanelPageType = 'Vanity URL'; break;
      case 'Job Search Home': mixpanelPageType = 'Job Search Home'; break;
      case 'Jobs Directory Page': mixpanelPageType = 'Jobs DIRP'; break;
      case 'Enhanced Directory Page': mixpanelPageType = 'Enhanced DIRP'; break;
      case 'Salary Page': mixpanelPageType = 'Salary Page'; break;
      case 'Jobs SERP': mixpanelPageType = 'Jobs SERP'; break;
      case 'Organic Job': mixpanelPageType = 'Organic Job'; break;
      case 'Job Browse Home': mixpanelPageType = 'Browse Jobs'; break;
      case 'Single Page Reg-to-SERP': mixpanelPageType = 'Single Page Reg-to-SERP'; break;
      case 'Top Results Page': mixpanelPageType = 'Top Results Page'; break;
      case 'Salary Data Widget': mixpanelPageType = 'Salary Data Widget'; break;
      case 'Individual Job Page':
        mixpanelPageType = window.zr.event.hasApplyUrl ? 'External Apply Job' : 'Zip Apply Job';
        break;
    }

    switch (pagepathparam) {
      default: break;
      case '/my-jobs?show=draft': mixpanelPageType = 'Employer - Draft Jobs'; break;
    }
  }

  if (pagepath === '/blog') {
    mixpanelPageType = 'Blog Home';
  } else if (pagepath.match(/^\/blog\//)) {
    mixpanelPageType = 'Blog Page';
  } else if (pagepath.match(/^\/contact\/survey\//)) {
    mixpanelPageType = 'Contact Survey Landing';
  } else if (pagepath.match(/^\/candidate\/zipresume\/verify\//)) {
    mixpanelPageType = 'Edit Resume';
  } else if (pagepath.match(/^\/candidate\/unsubscribe\//)) {
    mixpanelPageType = 'Candidate - Job Alert Unsubscribe';
  } else if (pagepath.match(/^\/submit-reference\//)) {
    mixpanelPageType = 'Reference Submit Form';
  } else if (pagepath.match(/^\/reference-giver\/create-alert\//)) {
    mixpanelPageType = 'Reference Giver - Create Alert';
  } else if (pagepath.match(/^\/user\/details\/\?unsub/)) {
    mixpanelPageType = 'Employer - Unsubscribe';
  } else if (pagepath.match(/^\/user\/unsubscribe/)) {
    mixpanelPageType = 'Employer - Unsubscribe';
  } else if (pagepath.match(/^\/candidates/)) {
    mixpanelPageType = 'Employer - My Candidates';
  }

  if (typeof mixpanelPageType === 'undefined') {
    // eslint-disable-next-line camelcase
    const { saw_registered_pixels } = properties;
    // eslint-disable-next-line camelcase
    if (saw_registered_pixels === 0) {
      mixpanelPageType = 'Employer - Payment Complete Page';
    }
  }

  properties.non_interaction = 1;

  if (mixpanelPageType) {
    properties.mixpanel_page_type = mixpanelPageType;
  }

  if (zr?.page.model?.is_zremployerapp === true) {
    properties.mobile_webview = 1;
  }

  // Handle adding ab_test property or add to existing
  // eslint-disable-next-line camelcase
  let { ab_tests } = properties;
  // eslint-disable-next-line camelcase
  if (!ab_tests) {
    // eslint-disable-next-line camelcase
    ab_tests = {};
  }

  if (abTest) {
    Object.assign(ab_tests, abTest.ab_tests);
    // eslint-disable-next-line camelcase
    properties.ab_tests = ab_tests;
  }

  logEvent('page_view', properties);
  window.zr.event.pageViewFired = true;
};

// make functions available in legacy locations
window.zr.event.logPageView = logPageView;
window.logPageView = logPageView;
window.$ = window.$ || {};
window.$.log_event = logEvent;
